module.exports = __webpack_public_path__ + "img/skala-1862.4d5c1e25.png";